import React, { useState } from "react";
import "./InputForm.scss";
import styled from "styled-components";
import { FaEye, FaEyeSlash } from "react-icons/fa";


const ShowPasswordIcon = styled.span`
  cursor: pointer;
  color: rgba(255, 255, 255, 0.55);
  position: absolute;
  right: 14px;
  top: 70%;
  transform: translateY(-70%);
  transition: color 0.15s;

  &:hover { color: #fff; }
`;


const InputForm = (props) => {
    const { id, value, onChange, placeholder, label = "", validationSchema, error, type = "text" | "password"
    } = props;


    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const validateValue = async (inputValue) => {
        if (!validationSchema) return;

        try {
            await validationSchema.validateAt(id, { [id]: inputValue });
        } catch (err) {
        }
    };

    const handleChange = (event) => {
        const { value } = event.target;
        onChange(event);
        validateValue(value);
    };

    return (
        <div className="container-input">
            <div>
                {label && <label htmlFor={id} >{label}</label>}
                {error && <p className="error-message">{error}</p>}
            </div>
            <input
                id={id}
                type={type === "password" ? (showPassword ? "text" : "password") : type}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                className={error ? "error" : ""}
            />

            {type === "password" && (
                <ShowPasswordIcon
                    onClick={togglePasswordVisibility}
                    role="button"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                >
                    {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                </ShowPasswordIcon>
            )}
        </div>
    );
};

export default InputForm;
